export default __webpack_public_path__ + "static/media/4.15c33c2c.png";